import axiosInstance from 'service/axiosInstance';
import { GlobalSearchApiResponse } from 'types/globalSearch';

export const globalSearch = async (
  searchQuery: string,
  projectUuid?: string,
): Promise<GlobalSearchApiResponse> => {
  const params: Record<string, string> = { searchQuery };
  if (projectUuid) params.projectUuid = projectUuid;
  const { data } = await axiosInstance.get<{ response: GlobalSearchApiResponse }>(
    'pmo/global-search',
    { params },
  );
  return data.response;
};

export const getRecentlyViewed = async (projectUuid?: string): Promise<GlobalSearchApiResponse> => {
  const params: Record<string, string> = {};
  if (projectUuid) params.projectUuid = projectUuid;
  
  const { data } = await axiosInstance.get<{ response: GlobalSearchApiResponse }>(
    'pmo/recently-viewed',
    { params }
  );
  return data.response;
};
